<template>
  <div>
    <el-card class="page-container">
      <el-row class="title-biaoti">货币详情配置</el-row>
      <el-row class="search"
        ><el-button type="primary" @click="query" :loading="login">刷新 </el-button>
        <el-button type="warning" @click="operate(1)">新增 </el-button></el-row
      >
      <el-row>
        <el-table :data="datalist" style="width: 100%" v-loading="login" stripe border>
          <el-table-column prop="currencyCode" label="货币码"> </el-table-column>
          <el-table-column prop="currencyType" label="货币类型"> </el-table-column>
          <el-table-column prop="currencyUnit" label="货币单位"> </el-table-column>
          <el-table-column prop="currencyName" label="货币名"> </el-table-column>
          <el-table-column prop="currencyIcon" label="货币图标">
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.currencyIcon"
                :preview-src-list="[scope.row.currencyIcon]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="currencyDesc" label="货币描述"> </el-table-column>
          <el-table-column prop="operator" label="操作人"> </el-table-column>
          <el-table-column prop="createDate" label="创建时间"> </el-table-column>
          <el-table-column prop="fixDate" label="修改时间"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope"
              ><el-button type="primary" @click="operate(2, scope.row)" size="mini"
                >修改
              </el-button>
              <el-button type="danger" @click="operate(3, scope.row.id)" size="mini"
                >删除
              </el-button>
            </template></el-table-column
          >
        </el-table>
      </el-row>
      <el-dialog
        :title="type ? '新增货币详情配置' : '编辑货币详情配置'"
        :visible.sync="dialog"
        width="50%"
        :before-close="handleClose"
      >
        <div class="item">
          <span>货币单位：</span><el-input type="text" v-model="data.unit"></el-input>
        </div>
        <div class="item">
          <span>货币名称：</span><el-input type="text" v-model="data.name"></el-input>
        </div>
        <div class="item">
          <span>货币图标：</span
          ><el-upload
            class="avatar-uploader"
            action=""
            :auto-upload="false"
            :show-file-list="false"
            :on-change="changfile"
            ref="upload"
          >
            <el-image
              v-if="data.icon !== ''"
              style="width: 178px; height: 178px"
              :src="data.icon"
              fit="scale-down"
            ></el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <div class="item">
          <span>货币描述：</span><el-input type="text" v-model="data.desc"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="operate(4)" type="primary" v-if="type" :loading="dwnload">
            新 增
          </el-button>
          <el-button @click="operate(5)" type="primary" v-if="!type" :loading="dwnload">
            编 辑
          </el-button>
          <el-button @click="handleClose">取 消</el-button>
        </span>
      </el-dialog>
    </el-card>
    <el-card class="page-container">
      <el-row class="title-biaoti">货币详情配置操作记录</el-row>
      <el-row class="search"
        ><el-button type="primary" @click="query1" :loading="login1">刷新 </el-button>
      </el-row>
      <el-row>
        <el-table :data="datalist1" style="width: 100%" v-loading="login1" stripe border>
          <el-table-column prop="dataId" label="源数据id"> </el-table-column>
          <el-table-column prop="opType" label="操作类型">
            <template slot-scope="scope">
              <p v-if="scope.row.opType == 1">增加</p>
              <p v-if="scope.row.opType == 2">修改</p>
              <p v-if="scope.row.opType == 3">删除</p>
            </template>
          </el-table-column>
          <el-table-column prop="currencyCode" label="货币码"> </el-table-column>
          <el-table-column prop="currencyType" label="货币类型"> </el-table-column>
          <el-table-column prop="currencyUnit" label="货币单位"> </el-table-column>
          <el-table-column prop="currencyIcon" label="货币图标">
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.currencyIcon"
                :preview-src-list="[scope.row.currencyIcon]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="currencyDesc" label="货币描述"> </el-table-column>
          <el-table-column prop="currencyName" label="货币名"> </el-table-column>
          <el-table-column prop="operator" label="操作人"> </el-table-column>
          <el-table-column prop="createDate" label="创建时间"> </el-table-column>
        </el-table>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      login: false,
      login1: false,
      datalist: [],
      datalist1: [],
      dialog: false,
      dwnload: false,
      type: true,
      data: { id: "", unit: "", name: "", icon: "", desc: "" },
    };
  },
  created() {
    this.query();
    this.query1();
  },
  methods: {
    async query() {
      this.login = true;
      const { data: res } = await this.$axios({
        type: "GET",
        url: this.$store.getters.path.config_currency_query,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      });
      this.login = false;
      if (res.code != 0) return this.$message(res.msg);
      this.datalist = res.data.data;
    },
    async query1() {
      this.login1 = true;
      const { data: res } = await this.$axios({
        type: "GET",
        url: this.$store.getters.path.config_currencylog_query,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      });
      this.login1 = false;
      if (res.code != 0) return this.$message(res.msg);
      this.datalist1 = res.data.data;
    },
    async operate(type, obj) {
      if (type == 1) {
        this.dialog = true;
        this.type = true;
      } else if (type == 2) {
        this.type = false;
        this.dialog = true;
        this.data.id = obj.id;
        this.data.unit = obj.currencyUnit;
        this.data.name = obj.currencyName;
        this.data.icon = obj.currencyIcon;
        this.data.desc = obj.currencyDesc;
      } else if (type == 3) {
        this.$confirm("确认删除此项货币详情配置", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            const { data: res } = await this.$axios(
              this.$store.getters.path.config_currency_delete +
                "?username=" +
                this.$store.getters.username +
                "&token=" +
                this.$store.getters.token +
                "&id=" +
                obj,
              {}
            );
            if (res.code !== 0) return this.$message.error("删除失败");
            this.$message.success("删除成功");
            this.query();
            this.query1();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else if (type == 4) {
        const { data: res } = await this.$axios({
          type: "GET",
          url: this.$store.getters.path.config_currency_add,
          withCredentials: true,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
            unit: this.data.unit,
            name: this.data.name,
            icon: this.data.icon,
            desc: this.data.desc,
          },
        });
        this.handleClose();
        if (res.code != 0) return this.$message(res.msg);
        this.query();
        this.query1();
      } else if (type == 5) {
        const { data: res } = await this.$axios({
          type: "GET",
          url: this.$store.getters.path.config_currency_update,
          withCredentials: true,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
            id: this.data.id,
            unit: this.data.unit,
            name: this.data.name,
            icon: this.data.icon,
            desc: this.data.desc,
          },
        });
        this.handleClose();
        if (res.code != 0) return this.$message(res.msg);
        this.query();
        this.query1();
      }
    },
    handleClose() {
      this.data = { id: "", unit: "", name: "", icon: "", desc: "" };
      this.$refs.upload.clearFiles();
      this.dialog = false;
    },
    async changfile(file) {
      this.dwnload = true;
      const formdata = new FormData();
      formdata.append("file", file.raw);
      formdata.append("cover", 0);
      formdata.append("dir", "icon/currency");
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        formdata
      );
      this.dwnload = false;
      if (res.code !== 0) {
        this.$refs.upload.clearFiles();
        return this.$message.error("文件上传失败请重新选择文件上传");
      }
      this.data.icon = res.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;
  > * {
    margin: 0 3px;
  }
}
.item {
  display: flex;
  align-items: center;
  padding: 5px 0;
  span {
    white-space: nowrap;
    padding: 0 5px;
  }
}
</style>
